import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../config/Urls";
import Storage from "../utils/HandelLocalStorage";

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 18000,
  params: {},
});

// instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
// instance.defaults.headers.post['Content-Type'] = 'application/json';
let token = "";
Storage.retrieveItem("userDetails").then((params) => {
  // console.log("Async User form axios", params);
  if (params === null || params === undefined || params === "") {
  } else {
    const userDetails = JSON.parse(params);
    token = userDetails?.token;
  }
});

// Add a request interceptor
instance.interceptors.request.use(
  function (config: any) {
    if (token) {
      // config.headers["Authorization"] = "Bearer " + token;
      config.headers.Authorization = token;
    }
    // console.log("++++++++++Request Config++++++++++", JSON.stringify(config));
    return config;
  },
  function (error: any) {
    // return Promise.reject(error);
    console.log("error from interceptor request", error);
    return Promise.reject(error);
    // return error;
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response: any) {
    // console.log('++++++++++Response Config++++++++++', response);
    return response;
  },
  function (error: any) {
    console.log("error from interceptor response", error);
    if (error.response) {
      if (error.response.status === 400 || error.response.status === 413) {
        toast.error(error.response.data.message || "Request too large or invalid request");
      } else {
        toast.error(error.response.data.message || "An unexpected error occurred");
      }
    } else if (error.request) {
      // The request was made but no response was received
      toast.error("Network error: No response from server. Check CORS or connectivity.");
    } else {
      // Something happened in setting up the request that triggered an Error
      toast.error("Error: " + error.message);
    }
    return Promise.reject(error);
  }
);


export default instance;
